<template>
  <v-overlay :value="loading.isShow">
    <v-progress-circular indeterminate color="_light_grey" size="70">{{ loadingText }}</v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Loading',
  data: () => ({}),
  computed: {
    ...mapState('loading', ['loading']),
    loadingText() {
      if (this.loading.isNum) return this.loading.value;
      return this.$t(this.loading.text);
    },
  },
};
</script>
